import * as React from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { cn } from '@noor/lib/cn';

function RadioGroup({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn('grid gap-3', className)}
      {...props}
    />
  );
}

function RadioGroupItem({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item>) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        // Figma sort/radio (Noor-CPanel 1033:19839): 20px disc with a 2px
        // ring — gray-300 idle, brand orange checked — over a card disc with
        // an orange 54% dot. A checked disc keeps its ring when disabled.
        'aspect-square size-5 shrink-0 rounded-full border-2 border-control-border bg-card transition-[color,box-shadow] outline-none',
        'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50',
        'data-[state=checked]:border-control-bg-checked',
        'aria-invalid:border-input-border-invalid aria-invalid:ring-input-border-invalid/20',
        'disabled:cursor-not-allowed disabled:data-[state=unchecked]:border-form-control-border-soft',
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="flex size-full items-center justify-center"
      >
        <span className="size-[65%] rounded-full bg-control-bg-checked" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
}

export { RadioGroup, RadioGroupItem };
